import React, { useState, useEffect } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { TextField, MenuItem, Box } from "@mui/material";

function FilesTable({ onFileSelect }) {
  const [files, setFiles] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(0);
  const [filters, setFilters] = useState({
    name: "",
    status: "",
    from: "",
    to: ""
  });

  const pageSize = 20;

  useEffect(() => {
    const query = new URLSearchParams({
      page: page + 1, // API expects 1-based page
      limit: pageSize,
      ...filters
    });

    fetch(`/api/files?${query.toString()}`)
      .then(res => res.json())
      .then(data => {
        // expect API to return { files: [], total }
        setFiles(data || []);
        setTotal(data.length || 0);
        console.log(data);
      })
      .catch(err => {
        console.error("Error fetching files:", err);
        setFiles([]);
        setTotal(0);
      });
  }, [page, filters]);

  const columns = [
    { field: "fileid", headerName: "ID", width: 120 },
    { field: "file_name", headerName: "File Name", flex: 1 },
    { field: "status", headerName: "Status", width: 150 },
    { field: "total_customers", headerName: "Total", width: 100 },
    { field: "pending_count", headerName: "Pending", width: 100 },
    { field: "in_progress_count", headerName: "In progress", width: 100 },
    { field: "failed_count", headerName: "Failed", width: 100 },
    { field: "completed_count", headerName: "Completed", width: 100 },
    {
      field: "created_at",
      headerName: "Created At",
      width: 200,
      valueGetter: (params) => {
        const raw = params;
        return raw ? new Date(raw).toLocaleString() : "";
      }
    }
  ];

  return (
    <Box>
      {/* Filters */}
      <Box display="flex" gap={2} marginBottom={2}>
        <TextField
          label="Search by Name"
          value={filters.name}
          onChange={e => {
            setPage(0); // reset to first page
            setFilters({ ...filters, name: e.target.value });
          }}
        />
        <TextField
          select
          label="Status"
          value={filters.status}
          onChange={e => {
            setPage(0);
            setFilters({ ...filters, status: e.target.value });
          }}
          style={{ width: 150 }}
        >
          <MenuItem value="">All</MenuItem>
          <MenuItem value="completed">Completed</MenuItem>
          <MenuItem value="completed with errors">Completed with errors</MenuItem>
          <MenuItem value="failed">Failed</MenuItem>
          <MenuItem value="pending">Pending</MenuItem>
          <MenuItem value="in-progress">In Progress</MenuItem>
        </TextField>
        <TextField
          type="date"
          label="From"
          InputLabelProps={{ shrink: true }}
          value={filters.from}
          onChange={e => {
            setPage(0);
            setFilters({ ...filters, from: e.target.value });
          }}
        />
        <TextField
          type="date"
          label="To"
          InputLabelProps={{ shrink: true }}
          value={filters.to}
          onChange={e => {
            setPage(0);
            setFilters({ ...filters, to: e.target.value });
          }}
        />
      </Box>

      {/* Table */}
      <div style={{ width: "100%" }}>
        <DataGrid
          rows={files}
          columns={columns}
          rowCount={total}
          pageSizeOptions={[pageSize]}
          paginationMode="server"
          paginationModel={{ page, pageSize }}
          onPaginationModelChange={(model) => setPage(model.page)}
          onRowClick={({ row }) => onFileSelect(row)}
          getRowId={(row) => row.fileid} // important: use fileid as unique key
        />
      </div>
    </Box>
  );
}

export default FilesTable;
